import { Divider, Flex, Heading } from "@chakra-ui/react";
import React from "react";
import { RiArrowRightSLine } from "react-icons/ri";
import { WithId, WithoutId } from "src/types/id";
import { TagGroup } from "src/types/tags";
import { AddTagGroup } from "./TagGroups/AddTagGroup";
import { EditTagGroup } from "./TagGroups/EditTagGroup";
import { TagGroupName } from "./TagGroups/TagGroupName";
import { TagsListEventHandler } from "./types";

export type Props = {
  tagGroups: TagGroup<WithId>[];
  error?: string;
  onNewTagGroupSaving?: (
    tagGroup: TagGroup<WithoutId>,
    onSuccess: () => void
  ) => Promise<void>;
  onEditTagGroupSaving?: (
    id: uuid,
    tagGroup: TagGroup<WithId>,
    onSuccess: () => void
  ) => Promise<void>;
  onDeleteTagGroupSaving?: (id: uuid, onSuccess: () => void) => Promise<void>;
  onCloseManageTagGroupDialog?: () => void;
} & TagsListEventHandler;

export const SelectTagGroup: React.FC<Props> = (props) => {
  const {
    tagGroups,
    error,
    onSelectTagGroup,
    onNewTagGroupSaving,
    onEditTagGroupSaving,
    onDeleteTagGroupSaving,
    onCloseManageTagGroupDialog,
  } = props;

  return (
    <Flex direction="column">
      <Flex direction="column">
        <Flex p="4" justifyContent="space-between">
          <Heading as="h3" size="md">
            Tag groups
          </Heading>

          <AddTagGroup
            onNewTagGroupSaving={onNewTagGroupSaving}
            onCloseManageTagGroupDialog={onCloseManageTagGroupDialog}
            error={error}
          />
        </Flex>
        <Divider />
      </Flex>
      <Flex direction="column" padding="4" overflowY="auto" gap={2}>
        {tagGroups.map((tagGroup) => (
          <Flex
            key={tagGroup.id}
            justifyContent="space-between"
            alignItems="center"
          >
            <TagGroupName
              name={tagGroup.name}
              fontSize="sm"
              isExternal={tagGroup.is_external}
            />
            <Flex gap={4} alignItems="center">
              {!tagGroup.is_default && (
                <EditTagGroup
                  tagGroup={tagGroup}
                  onEditTagGroupSaving={onEditTagGroupSaving}
                  onDeleteTagGroupSaving={onDeleteTagGroupSaving}
                  onCloseManageTagGroupDialog={onCloseManageTagGroupDialog}
                />
              )}

              <RiArrowRightSLine
                aria-label="Select tag group"
                onClick={() =>
                  onSelectTagGroup && onSelectTagGroup(tagGroup.id)
                }
                cursor="pointer"
              />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
